<template>
  <c-row>
    <c-col col="12" xl="8">
      <transition name="slide">
        <c-card>
          <c-card-header>
            Users
          </c-card-header>
          <c-card-body>
            <c-data-table
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="5"
              clickable-rows
              :active-page="activePage"
              @row-clicked="rowClicked"
            >
              <template #status="data">
                <td>
                  <c-badge :color="getBadge(data.item.status)">
                    {{ data.item.status }}
                  </c-badge>
                </td>
              </template>
            </c-data-table>
            <c-pagination
              align="center"
              :double-arrows="false"
              :active-page="activePage"
              :pages="5"
              @update:activePage="pageChange"
            />
          </c-card-body>
        </c-card>
      </transition>
    </c-col>
  </c-row>
</template>

<script>
import usersData from './UsersData';

export default {
  name: 'Users',
  data() {
    return {
      items: usersData,
      fields: [
        { key: 'username', label: 'Name', _classes: 'font-weight-bold' },
        { key: 'registered' },
        { key: 'role' },
        { key: 'status' },
      ],
      activePage: 1,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    getBadge(status) {
      switch (status) {
        case 'Active':
          return 'success';
        case 'Inactive':
          return 'secondary';
        case 'Pending':
          return 'warning';
        case 'Banned':
          return 'danger';
        default:
          'primary';
      }
    },
    rowClicked(item, index) {
      this.$router.push({ path: `users/${index + 1}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
  },
};
</script>
